import React from 'react';
import { Chip } from '@mui/material';
import { getRoleChipColors, getRoleDisplayName } from './userDisplayUtils';

interface UserRoleChipProps {
  role?: string;
}

/** Rounded role pill tinted per the design's role color map. */
const UserRoleChip = ({ role }: UserRoleChipProps) => {
  const label = getRoleDisplayName(role);
  if (!label) {
    return null;
  }

  const { bg, color } = getRoleChipColors(role);

  return (
    <Chip
      size="small"
      label={label}
      sx={{
        backgroundColor: bg,
        color,
        fontWeight: 500,
        height: 24,
        borderRadius: '16px',
      }}
    />
  );
};

export default UserRoleChip;
